import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import CreateDefaultIllustrationPage from '../pages/CreateDefaultIllustrationPage';
import DefaultIllustrationDetailsPage from '../pages/DefaultIllustrationDetailsPage';
import IllustrationHomePage from '../pages/IllustrationHomePage';
import UpdateDefaultIllustrationPage from '../pages/UpdateDefaultIllustrationPage';
import UpdateRegionalIllustrationPage from '../pages/UpdateRegionalIllustrationPage';
import Permission from '../../authorization/components/Permission';
import actions from '../../authorization/models/actions';
import UnauthorizedAccessPage from '../../common/pages/UnauthorizedAccessPage';
import ConfigProvider from '../../common/components/ConfigProvider';
import configKeys from '../../common/models/config-keys';

function IllustrationAssetsRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <IllustrationHomePage />
                </Route>
                <Route exact path={`${path}/${routes.CREATE}`}>
                    <ConfigProvider
                        configKey={
                            configKeys.IS_CREATE_DEFAULT_ILLUSTRATION_ENABLED
                        }
                        alternate={<UnauthorizedAccessPage />}>
                        <Permission
                            action={actions.CREATE_ILLUSTRATION}
                            alternate={<UnauthorizedAccessPage />}>
                            <CreateDefaultIllustrationPage />
                        </Permission>
                    </ConfigProvider>
                </Route>
                <Route exact path={`${path}/:id`}>
                    <DefaultIllustrationDetailsPage />
                </Route>
                <Route exact path={`${path}/:id/${routes.UPDATE}`}>
                    <Permission
                        action={actions.CREATE_ILLUSTRATION}
                        alternate={<UnauthorizedAccessPage />}>
                        <UpdateDefaultIllustrationPage />
                    </Permission>
                </Route>
                <Route
                    exact
                    path={`${path}/:defaultId/:regionalId/${routes.UPDATE}`}>
                    <Permission
                        action={actions.CREATE_ILLUSTRATION}
                        alternate={<UnauthorizedAccessPage />}>
                        <UpdateRegionalIllustrationPage />
                    </Permission>
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default IllustrationAssetsRouter;
